export const PRIMARY_COLOR = 'rgb(203, 108, 230)';
export const SECONDARY_COLOR = 'rgb(220, 143, 241)';
export const TERTIARY_COLOR = 'rgb(250, 229, 255)';
export const HEADER_COLOR = 'rgb(153, 0, 204)';
export const TEXT_COLOR = 'rgb(110, 121, 125)';
export const DESCRIPTION_COLOR = 'rgb(166, 166, 166)';
export const CHECK_ICON_COLOR = '#00bf63';

